<div class="list-options">
  <div class="cards">
    <app-stat
      fxFlex="auto"
      *ngFor="let card of cards"
      [bgClass]="'danger'"
      [icon]="card.icon"
      [count]="card.count"
      [label]="card.label"
      (click)="goTo(card.to)"
      [loaded]="dataLoaded"
    ></app-stat>
  </div>
</div>
